module.exports = __webpack_public_path__ + "img/gift4-01-c10-t1.7836343f.png";